import type { InventoryControlCategory, ReceivingVariantSummary } from './fixtures'

export const inventoryControls = {
  lot_number: { label: 'Lot number', field: 'lot', date: false },
  manufacture_date: { label: 'Manufacture date', field: 'manufactureDate', date: true },
  best_before_date: { label: 'Best-before date', field: 'bestBeforeDate', date: true },
  expiry_date: { label: 'Expiry date', field: 'expiry', date: true },
  received_date: { label: 'Received date', field: 'receivedDate', date: true },
} as const

export const inventoryControlFor = (variant: ReceivingVariantSummary | null) => {
  const category: InventoryControlCategory = variant?.inventoryControlCategory ?? 'received_date'
  return { category, ...inventoryControls[category] }
}
